import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const UserInfoKey = 'Admin-UserInfo'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserInfo() {
  return Cookies.getJSON(UserInfoKey)
}

export function setUserInfo(UserInfo) {
  return Cookies.set(UserInfoKey,JSON.stringify(UserInfo))
}

export function removeUserInfo() {
  return Cookies.remove(UserInfoKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js